import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { pairwise } from 'rxjs/operators';
import { HeimvorteilProduktart } from 'src/shared/enum';
import { toggleEditMode } from '../../../shared/utils';
import { CustomValidator } from '../../../shared/validation';
import { PopupService } from '../../service/popup.service';
import { ValidationService } from '../../service/validation.service';

@Component({
  selector: 'app-erhoehung-hoechsthaftungssumme',
  templateUrl: './erhoehung-hoechsthaftungssumme.component.html',
  styleUrls: ['./erhoehung-hoechsthaftungssumme.component.scss']
})
export class ErhoehungHoechsthaftungssummeComponent implements OnInit, OnChanges {

  @Input()
  parentFormGroupDirective: FormGroupDirective;

  @Input()
  formGroup: UntypedFormGroup;

  @Input()
  showGroup = true;

  @Input()
  tarifHoechsthaftungssumme: number;

  @Input()
  expertMode: boolean;

  @Input()
  produktart: HeimvorteilProduktart;

  @Output()
  calculateRatePendingEvent = new EventEmitter<void>();

  constructor(public translateService: TranslateService, public popupService: PopupService, public validationService: ValidationService) { }

  static createFormGroup(fb: UntypedFormBuilder, expertMode: boolean, produktart: HeimvorteilProduktart) {
    return fb.group({
      erhoehungHoechsthaftungssumme: new UntypedFormControl('', Validators.required),
      tarifVersicherungssumme: new UntypedFormControl({ value: '', disabled: true }),
      hoechsthaftungssummeFreieEingabe: new UntypedFormControl('', [Validators.required, Validators.pattern('^[0-9]*$')])
    }, { validator: [expertMode && produktart === HeimvorteilProduktart.Haushalt ?
      CustomValidator.validateHoechsthaftungssummeExpert :
      CustomValidator.validateHoechsthaftungssumme] });
  }

  ngOnInit(): void {
    this.onValueChanged();
    this.toggleEditMode();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.showGroup && changes.showGroup.currentValue !== changes.showGroup.previousValue) {
      this.toggleEditMode();
    }
    if (changes.tarifHoechsthaftungssumme && changes.tarifHoechsthaftungssumme.currentValue !== changes.tarifHoechsthaftungssumme.previousValue) {
      this.tarifVersicherungssumme.setValue(this.tarifHoechsthaftungssumme);
    }
  }

  get erhoehungHoechsthaftungssumme() { return this.formGroup.get('erhoehungHoechsthaftungssumme'); }
  get tarifVersicherungssumme() { return this.formGroup.get('tarifVersicherungssumme'); }
  get hoechsthaftungssummeFreieEingabe() { return this.formGroup.get('hoechsthaftungssummeFreieEingabe'); }

  get showErhoehungHoechsthaftungssumme() {
    return this.showGroup && this.erhoehungHoechsthaftungssumme.value === 'ja' ? true : false;
  }

  get isHaushalt() {
    return this.produktart === HeimvorteilProduktart.Haushalt;
  }

  toggleEditMode(): void {
    toggleEditMode(this.erhoehungHoechsthaftungssumme, this.showGroup);
    toggleEditMode(this.hoechsthaftungssummeFreieEingabe, this.showErhoehungHoechsthaftungssumme);
  }

  onValueChanged(): void {
    this.erhoehungHoechsthaftungssumme.valueChanges.subscribe(() => {
      this.toggleEditMode();
    });
    this.erhoehungHoechsthaftungssumme
      .valueChanges
      .pipe(pairwise())
      .subscribe(([prev, next]: [any, any]) => {
        if (prev === 'ja' && next === 'nein') {
          this.calculateRatePendingEvent.emit();
        }
      });
    this.hoechsthaftungssummeFreieEingabe.valueChanges.subscribe(() => {
      this.calculateRatePendingEvent.emit();
    });
  }

  hoechsthaftungssummeUnterversicherung(): boolean {
    return this.expertMode &&
      this.hoechsthaftungssummeFreieEingabe.valid &&
      this.hoechsthaftungssummeFreieEingabe.value < this.tarifVersicherungssumme.value ? true : false;
  }

  getHoechsthaftungssumme(): number {
    return this.hoechsthaftungssummeFreieEingabe.value;
  }

  setHoechsthaftungssumme(summe: number) {
    this.hoechsthaftungssummeFreieEingabe.setValue(summe);
  }
}
